import axios from "axios";
import { config_headers, servicelist, URL_API } from "../Config";

export const pCtCiaCameraList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios
                .post(URL_API(`${servicelist.CtService}p_ct_cia_camera_list`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const pCtCiaCameraInfo = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios
                .post(URL_API(`${servicelist.CtService}p_ct_cia_camera_info`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const pCtCiaCameraUpdate = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios
                .post(URL_API(`${servicelist.CtService}p_ct_cia_camera_update`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};